import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const CONTACTS = [
  { display: "50743312", intl: "96550743312" },
  { display: "55966106", intl: "96555966106" },
];

const WHATSAPP_PATH =
  "M20.52 3.48A11.78 11.78 0 0 0 12.02 0C5.43 0 .07 5.36.07 11.95c0 2.1.55 4.14 1.6 5.95L0 24l6.25-1.64a11.9 11.9 0 0 0 5.7 1.45h.01c6.59 0 11.95-5.36 11.95-11.95 0-3.2-1.25-6.2-3.39-8.38zM12 21.6h-.01a9.92 9.92 0 0 1-5.05-1.39l-.36-.21-3.71.97.99-3.62-.23-.37a9.9 9.9 0 0 1-1.52-5.27C2.11 6.17 6.31 2 11.97 2A9.9 9.9 0 0 1 22 11.95c0 5.66-4.2 9.65-10 9.65zm5.56-7.31c-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.35.23-.65.08-.3-.15-1.25-.46-2.39-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.38-.02-.53-.07-.15-.66-1.6-.9-2.2-.24-.58-.49-.5-.66-.51l-.56-.01c-.2 0-.5.08-.76.38-.27.3-1.03 1-1.03 2.45 0 1.45 1.06 2.86 1.2 3.06.14.2 2.04 3.12 4.94 4.38.69.3 1.23.48 1.65.62.69.22 1.33.19 1.83.11.55-.08 1.7-.69 1.94-1.37.24-.68.24-1.26.17-1.38-.07-.12-.27-.19-.57-.34z";

const PHONE_PATH =
  "M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.36 11.36 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z";

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const toggleRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <div className="whatsapp-float-wrap" ref={wrapRef}>
      <div
        id="whatsapp-contact-menu"
        className={`whatsapp-menu${open ? " is-open" : ""}`}
        role="dialog"
        aria-label="تواصل معنا"
        aria-hidden={!open}
        dir="rtl"
      >
        <div className="whatsapp-menu-title">تواصل معنا</div>
        <ul className="whatsapp-menu-list">
          {CONTACTS.map((contact) => (
            <li key={contact.intl} className="whatsapp-menu-item">
              <span className="whatsapp-menu-number" dir="ltr">
                {contact.display}
              </span>
              <div className="whatsapp-menu-actions">
                <a
                  className="whatsapp-menu-btn is-whatsapp"
                  href={`https://wa.me/${contact.intl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  tabIndex={open ? 0 : -1}
                  aria-label={`واتساب ${contact.display}`}
                  onClick={() => setOpen(false)}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d={WHATSAPP_PATH} />
                  </svg>
                  واتساب
                </a>
                <a
                  className="whatsapp-menu-btn is-call"
                  href={`tel:+${contact.intl}`}
                  tabIndex={open ? 0 : -1}
                  aria-label={`اتصال ${contact.display}`}
                  onClick={() => setOpen(false)}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d={PHONE_PATH} />
                  </svg>
                  اتصال
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <button
        type="button"
        ref={toggleRef}
        className="whatsapp-float"
        aria-label="تواصل معنا عبر واتساب"
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-controls="whatsapp-contact-menu"
        onClick={() => setOpen((value) => !value)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d={WHATSAPP_PATH} />
        </svg>
      </button>
    </div>
  );
}
